/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { isObject, isStringNotEmpty } from "utils/empty-exists";

export const news_category = [
    { value: "All", label: "- Any -" },
    { value: "Council", label: "Council" },
    { value: "Development", label: "Development" },
    { value: "District Hall", label: "District Hall" },
    { value: "Press release", label: "Press release" },
    { value: "Projects", label: "Projects" },
    { value: "Public safety", label: "Public safety" },
    { value: "Services", label: "Services" },
    { value: "Traffic", label: "Traffic" }
];
export const committee_categories = [
    { value: "All", label: "- Any -" },
    { value: "Arts and recreation", label: "Arts and recreation" },
    { value: "Building, development, and transportation", label: "Building, development, and transportation" },
    { value: "Environment", label: "Environment" },
    { value: "Finance and tax", label: "Finance and tax" },
    { value: "Local government and administration", label: "Local government and administration" },
    { value: "Social planning", label: "Social planning" },
];
export const event_categories = [
    { value: "All", label: "- Any -" },
    { value: "Mayor and Council appearances", label: "Mayor and Council appearances" },
    { value: "Council meetings and public hearings", label: "Council meetings and public hearings" },
    { value: "Volunteer Opportunity", label: "Volunteer Opportunity" },
    { value: "Open House", label: "Open House" },
    { value: "Performance", label: "Performance" },
    { value: "Workshop", label: "Workshop" },
    { value: "Public Gathering", label: "Public Gathering" },
];
// NOTE these are secondary categories
export const meeting_categories = [
    { value: "All", label: "- Any -" },
    { value: "Council workshops", label: "Council workshops" },
    { value: "Council regular meetings", label: "Council regular meetings" },
    { value: "Council special meetings", label: "Council special meetings" },
    { value: "Public hearings & meetings", label: "Public hearings & meetings" },
    { value: "Committee meetings", label: "Committee meetings" },
];
export const story_categories = [
    { value: "All", label: "- Any -" },
    { value: "Community involvement", label: "Community involvement" },
    { value: "Economy and finance", label: "Economy and finance" },
    { value: "Environment and sustainability", label: "Environment and sustainability" },
    { value: "Fire and Rescue Services", label: "Fire and Rescue Services" },
    { value: "Growth and development", label: "Growth and development" },
    { value: "Housing", label: "Housing" },
    { value: "Parks and green spaces", label: "Parks and green spaces" },
    { value: "Projects and infrastructure", label: "Projects and infrastructure" },
    { value: "Streets and transportation", label: "Streets and transportation" },
];
export const bylaw_categories = [
    { value: "All", label: "- Any -" },
    { value: "Animals", label: "Animals" },
    { value: "Building and development", label: "Building and development" },
    { value: "Business", label: "Business" },
    { value: "Enforcement/nuisance abatement", label: "Enforcement/nuisance abatement" },
    { value: "Environment", label: "Environment" },
    { value: "Finance and taxes", label: "Finance and taxes" },
    { value: "Local Government and administration", label: "Local Government and administration" },
];
export const devapp_categories = [
    { value: "All", label: "- Any -" },
    { value: "Residential Level 1: Rural Residential", label: "Residential Level 1: Rural Residential" },
    { value: "Residential Level 2: Detached Residential", label: "Residential Level 2: Detached Residential" },
    { value: "Residential Level 3: Attached Residential", label: "Residential Level 3: Attached Residential" },
    { value: "Residential Level 4: Transition Multifamily", label: "Residential Level 4: Transition Multifamily" },
    { value: "Residential Level 5: Low Density Apartment", label: "Residential Level 5: Low Density Apartment" },
    { value: "Residential Level 6: Medium Density Apartment", label: "Residential Level 6: Medium Density Apartment" },
    { value: "Commercial Residential Mixed Use Level 1", label: "Commercial Residential Mixed Use Level 1" },
    { value: "Commercial Residential Mixed Use Level 2", label: "Commercial Residential Mixed Use Level 2" },
    { value: "Commercial Residential Mixed Use Level 3", label: "Commercial Residential Mixed Use Level 3" },
    { value: "Commercial", label: "Commercial" },
    { value: "Institutional", label: "Institutional" },
    { value: "Light Industrial Artisan", label: "Light Industrial Artisan" },
    { value: "Industrial", label: "Industrial" },
    { value: "Light Industrial Commercial", label: "Light Industrial Commercial" },
    { value: "Light Industrial Commercial Mixed Use - Innovation District", label: "Light Industrial Commercial Mixed Use - Innovation District" },
    { value: "Light Industrial Residential Mixed Use - Innovation District", label: "Light Industrial Residential Mixed Use - Innovation District" },
    { value: "Parks, Open Space, and Natural Areas", label: "Parks, Open Space, and Natural Areas" },
];
export const permits_categories = [
    { value: "All", label: "- Any -" },
    { value: "Animals", label: "Animals" },
    { value: "Building, trades, mechanical", label: "Building, trades, mechanical" },
    { value: "Business", label: "Business" },
    { value: "Development", label: "Development" },
    { value: "Environmental", label: "Environmental" },
    { value: "Fire", label: "Fire" },
    { value: "Parks", label: "Parks" },
    { value: "Streets and transportation", label: "Streets and transportation" },
];
export const neigbourhoods = [
    { type: "All", value: "All", label: "- Any -" },
    { type: "Deep Cove", value: "Deep Cove", label: "Deep Cove" },
    { type: "Delbrook / Upper Lonsdale", value: "Delbrook / Upper Lonsdale", label: "Delbrook / Upper Lonsdale" },
    { type: "Lions gate / Lower Capilano", value: "Lions Gate / Lower Capilano", label: "Lions Gate / Lower Capilano" },
    { type: "Lynn Creek", value: "Lynn Creek", label: "Lynn Creek" },
    { type: "Lynn Valley", value: "Lynn Valley", label: "Lynn Valley" },
    { type: "Maplewood", value: "Maplewood", label: "Maplewood" },
    { type: "Seymour", value: "Seymour", label: "Seymour" },
    { type: "Upper Capilano", value: "Upper Capilano", label: "Upper Capilano" },
];
export const getNeighbourhoods = () => {
    return neigbourhoods;
};
export const dpa_categories = permits_categories;
export const licence_categories = permits_categories;
export const all_categories = [
    { type: "model.homepage", data: [] },
    { type: "model.news", data: news_category },
    { type: "model.committee", data: committee_categories },
    { type: "model.event", data: event_categories },
    { type: "model.meeting", data: meeting_categories }, // yes, this should be the same as event
    { type: "model.story", data: story_categories },
    { type: "model.story", data: permits_categories },
    { type: "model.dpa", data: dpa_categories },
    { type: "model.licence", data: licence_categories },
    { type: "model.bylaw", data: bylaw_categories },
    { type: "model.permit", data: permits_categories },
    { type: "model.development-application", data: neigbourhoods },
];
export const getCategory = (type) => {
    const result = all_categories.find((element) => element.type === type);
    let categories = [];
    if (isObject(result)) {
        categories = result.data;
    }
    return categories;
};
export const all_category_names = [
    { type: "model.news", name: "category" },
    { type: "model.committee", name: "category" },
    { type: "model.event", name: "category" },
    { type: "model.meeting", name: "meeting_category" },
    { type: "model.story", name: "category" },
    { type: "model.story", name: "category" },
    { type: "model.dpa", name: "category" },
    { type: "model.licence", name: "category" },
];
export const getCategoryName = (type) => {
    const result = all_category_names.find((element) => element.type === type);
    let name = "category";
    if (isStringNotEmpty(result?.type)) {
        name = result.name;
    }
    return name;
};

export const getEventCategories = (type) => {
    const categories = [];
    const { data } = all_categories.find((element) => element.type === type);
    const values = Object.values(data);
    for (const { label, value } of values) {
        categories.push({
            type: label,
            name: value,
        });
    }
    return categories;
};
export const getSelectedCategoryName = (type, value) => {
    const { data } = all_categories.find((element) => element.type === type) || { type, data: [] };
    const result = data.find((element) => element.value === value);
    let name = "All";
    if (isStringNotEmpty(result?.value)) {
        name = result.value;
    }
    return name;
};
